export class GroupConstants {
  public static readonly ADD_PROJECT_OPERATION = "Add";

  public static readonly REMOVE_PROJECT_OPERATION = "Remove";

  public static readonly REGISTRY_MATCH = "Match";

  public static readonly REGISTRY_MISMATCH = "Group membership mismatch";
}
